module.exports = __webpack_public_path__ + "img/ico_dots--bl.ee5a6b52.svg";